module.exports = __webpack_public_path__ + "img/estimated-insurance-required.16694c5d.png";